/*
  Returns a BOOLEAN

  Checks to see if an error exists for any of the passed key
*/

export default (keysArray, errorsTable) =>
  keysArray.some((key) => errorsTable[key]);
